import React from 'react';

import dayjs from 'dayjs';

import { useAvailableSingleCallJobs } from 'state/context/freelancer/FreelancerAvailableJobs';

import { createLocale } from 'locales';

import Typography from 'components/typography/typography';

import Icon from 'components/icon/icon';

interface DateholderProps {
  date: string;
}
const localize = createLocale('freelancerAvailableJobsLocales');

const AcceptedJobsNotifier: React.FC<DateholderProps> = ({ date }) => {
  const { acceptedJobs } = useAvailableSingleCallJobs();
  const todayAcceptedJobs = acceptedJobs.data
    .filter((job) => job.date === date)
    .sort((job1, job2) => {
      if (job1.start < job2.start) return -1;
      if (job1.start > job2.start) return 1;
      return 0;
    });
  const notify =
    !acceptedJobs.error &&
    !acceptedJobs.isLoading &&
    acceptedJobs.data &&
    todayAcceptedJobs.length > 0;

  return (
    <>
      {notify &&
        todayAcceptedJobs.map((job) => {
          return (
            <div
              key={job.id}
              className="container flex items-center justify-between pl-7 mb-2 mt-2 border rounded-md border-slate300 h-10 bg-bitterLemon"
            >
              <div className="flex justify-center items-center text-purple my-1">
                <Icon icon="clock" size={24} className="text-gray500" />
                <Typography
                  variant="body-large-bold"
                  as="h3"
                  className="text-gray-800 px-3 ml-2 rounded-lg bg-veryLightBlue"
                >
                  {`${dayjs(job.start, 'hh:mm:ss').format('hh:mm')} - ${dayjs(
                    job.end,
                    'hh:mm:ss',
                  ).format('hh:mm')}`}
                </Typography>
              </div>

              <div className="flex justify-center items-center text-purple my-1 invisible w-0 lg:visible lg:w-fit">
                <Icon icon="locationN" size={22} className="text-gray500" />
                <Typography
                  variant="body-large-bold"
                  as="h3"
                  className="text-gray600 px-3"
                >
                  <a
                    href={`https://maps.google.com/?q=${job.full_address}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {job?.full_address}
                  </a>
                </Typography>
              </div>

              <div className="flex justify-center items-center text-gray900 border-l-1 h-full mr-0 pl-2 pr-5 rounded-r-md bg-mediumBitterLemon hover:bg-darkBitterLemon">
                <a
                  href={`/freelancer/job/${job.id}/`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex justify-center items-center"
                >
                  <Icon
                    icon="info-circle"
                    size={24}
                    className="text-body-large text-gray500"
                  />
                  <Typography
                    variant="body-large-bold"
                    as="h3"
                    className="pl-2 text-gray600"
                  >
                    {localize('details')}
                  </Typography>
                </a>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default AcceptedJobsNotifier;
